import React from "react";
import { IconButton, FormLabel } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { FieldArrayFieldProps } from "../../../../../forms/fields/field-array/field-array-field.props";
import { TextField } from "../../../../../forms/fields/text-field/text-field.component";

import { useUnitLinksStyles } from "./unit-links.styles";

export const UnitLinks = (props: FieldArrayFieldProps) => {
  const classes = useUnitLinksStyles();

  const linkName = `${props.name}.${props.index}.unitLink`;

  return (
    <div className={classes.fieldWrapper}>
      <FormLabel htmlFor={linkName} className={classes.shrink}>
        {props.index + 1}
      </FormLabel>
      <div className={classes.grow}>
        <TextField
          disabled={props.disabled}
          form={props.form}
          name={linkName}
          size="small"
          userPermissions={props.userPermissions}
        />
      </div>
      <div className={classes.shrink}>
        <IconButton onClick={() => props.remove(props.index)} title="Delete">
          <CloseIcon />
        </IconButton>
      </div>
    </div>
  );
};
